//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { VTextField } from 'vuetify/lib';
import { PropsMixin, RulesMixin } from '../mixins';

export default {
  name: 'DfTextField',
  components: {
    VTextField,
  },
  mixins: [PropsMixin, RulesMixin],
  props: {
    /**
     * Field value
     * @type {object}
     */
    value: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      model: this.value || this.schema.value,
    };
  },
  computed: {
    inputType() {
      switch (this.schema.type) {
        case 'email':
          return 'email';
        case 'number':
          return 'number';
        case 'string':
          return 'text';
        default:
          return 'text';
      }
    },
    cleanedValue() {
      const model = this.model;
      if (this.schema.type === 'number') {
        return Number(model);
      }
      return this.model;
    },
  },
  watch: {
    value(newValue) {
      this.model = newValue;
    },
    // watch cleanedValue instead of model so that this
    // gets fired if either schema.type OR model changes
    cleanedValue(value) {
      this.$emit('input', value);
    },
  },
};
